import {
  ManualAndAutoFilledCriteriaObjectType,
  MonitoringRecordDataType,
} from '@app/interfaces/qm-module/qm-manage/qm-monioring-tasks.type';
import { Select, CircleButton, Box, Input, TooltipWrapper, Checkbox } from '@ui';
import React, { FC, useState } from 'react';

import useTranslation from '@app/hooks/use-translation';

import { pictogramsData } from '@app/components/metric-table-value-build';

import Icon from '@app/components/ui/icons';

import { QmAppealFullObjectType } from '@app/interfaces/qm-module/qm-appellations/qm-appellations.type';

import HistoryComponent from './history-component';
import { Hint, RecordEditTempType } from './record-monitoring';
import { DisplayScoreComponent } from './display-score';
import AppealStatusForRecord, { colorsForAppealBorder } from './appeal-status-for-record';

const CriteriaListMarkup: FC<{
  criteria?: ManualAndAutoFilledCriteriaObjectType[] | null;
  recordMonitoringData: MonitoringRecordDataType | undefined;
  editMode: boolean;
  criteriaToAppeal: Record<string, string | number>;
  handleIncludeCriteriaToAppeal(id: string): void;
  handleChangeCriteriaComment(value: string | number, id: string): void;
  appealSendMode: boolean;
  appealResolveMode: boolean | undefined;
  appealObject: QmAppealFullObjectType | undefined;
  criteriaEditObject: Record<string, RecordEditTempType>;
  setCriteriaEditObject: React.Dispatch<React.SetStateAction<Record<string, RecordEditTempType>>>;
  scalesColorsMap: Record<
    string,
    {
      [key: number]: string;
    }
  >;
}> = (props) => {
  const {
    criteria: criteriaList,
    appealObject,
    handleChangeCriteriaComment,
    handleIncludeCriteriaToAppeal,
    appealSendMode,
    appealResolveMode,
    recordMonitoringData,
    criteriaToAppeal,
    editMode,
    criteriaEditObject,
    setCriteriaEditObject,
    scalesColorsMap,
  } = props;
  const { t } = useTranslation('components.audio.monitoring');
  const [commentBlock, setCommentBlock] = useState<string[]>(
    appealResolveMode ? appealObject?.criteria?.map(({ id }) => id) || [] : [],
  );

  return (
    <div className="flex flex-col gap-[10px]">
      {[...(criteriaList || [])]
        .sort((a, b) => a.order - b.order)
        ?.map((criteria, index) => {
          const appealInfo = appealObject?.criteria.find((crit) => criteria.id === crit.id);
          function scaleRatingFilter(score: number | undefined) {
            if (recordMonitoringData?.rating_type === 'WEIGHT') {
              return (
                ((score || 0) / 100) *
                ((recordMonitoringData?.evaluation.score.max || 0) -
                  (recordMonitoringData.evaluation.score?.min || 0))
              ).toFixed(2);
            }
            return score;
          }
          const isSelectedCriteriaToAppeal =
            typeof criteriaToAppeal[criteria.id] === 'string' ||
            typeof criteriaToAppeal[criteria.id] === 'number';

          return (
            <div className="relative h-full w-full" key={criteria.id}>
              {appealSendMode && (
                <div className="">
                  <div className="flex absolute z-[1] left-[5px] top-[42px] h-full">
                    <Checkbox
                      checked={isSelectedCriteriaToAppeal}
                      onChange={() => handleIncludeCriteriaToAppeal(criteria.id)}
                    />
                  </div>
                  {isSelectedCriteriaToAppeal && (
                    <Box className="!bg-basic_app_bg w-[calc(100%-52px)] left-[26px] absolute  bottom-[10px] px-[10px] py-[10px]">
                      <div
                        style={{ zIndex: 101 + (criteriaList?.length || 0) - index }}
                        className=" relative"
                      >
                        {criteria.comments.type === 'INPUT' ? (
                          <Input
                            placeholder={t('comment_appeal_placeholder')}
                            defaultValue={criteriaToAppeal[criteria.id]}
                            onChange={(event) => {
                              handleChangeCriteriaComment(event.target.value, criteria.id);
                            }}
                          />
                        ) : (
                          <Select
                            dropWidth={246}
                            placeholder={t('comment_appeal_placeholder')}
                            options={
                              criteria.comments?.settings?.select.map((select) => {
                                return criteria.comments.settings?.display_type === 'ICON'
                                  ? {
                                      value: select.id,
                                      title: select.icon || 0,
                                    }
                                  : criteria.comments.settings?.display_type === 'VALUE_ICON'
                                  ? {
                                      value: select.id,
                                      title: select.desc,
                                      icon: pictogramsData[select.icon?.toString() || 0],
                                    }
                                  : {
                                      value: select.id,
                                      title: select.desc,
                                    };
                              }) || []
                            }
                            defaultValue={+criteriaToAppeal[criteria.id]}
                            onChange={(value) => {
                              handleChangeCriteriaComment(value, criteria.id);
                            }}
                            pictogramsMode={criteria.comments.settings?.display_type === 'ICON'}
                          />
                        )}
                      </div>
                    </Box>
                  )}
                </div>
              )}
              <div className={`px-[26px] relative ${isSelectedCriteriaToAppeal && 'pb-[60px]'}`}>
                <div className={`flex w-full h-full items-end justify-between`}>
                  {(!!appealInfo || isSelectedCriteriaToAppeal) && (
                    <div
                      style={{
                        borderColor:
                          appealObject?.status === 'ACCEPTED'
                            ? colorsForAppealBorder[1]
                            : appealObject?.status === 'DECLINED' ||
                              appealObject?.status === 'CLOSED'
                            ? colorsForAppealBorder[2]
                            : colorsForAppealBorder[0],
                      }}
                      className={`border left-[1.5%] bottom-0 rounded-defaultR absolute w-[97%] h-[calc(100%-10px)] pointer-events-none`}
                    />
                  )}
                  <div className=" text-1color text-[12px]  flex flex-col gap-[3px] ">
                    <div
                      className={`text-2color flex items-center w-fit text-[14px] px-[2px] ${
                        (!!appealInfo || isSelectedCriteriaToAppeal) && 'relative bg-white'
                        // 'border-r-solid border-l-solid border-r-black border-l-black border-r-[1px] border-l-[1px8]'
                      }`}
                    >
                      {criteria.name}
                      <Hint content={criteria.description} size={11} />
                      {typeof criteria?.crit_mform === 'number' && (
                        <div className="text-[11px] p-[2px_5px] mx-1 rounded-[24px] border-basic_red border-[1px] w-fit">
                          {t('crit_mf')}
                        </div>
                      )}
                      {appealObject && appealInfo && (
                        <AppealStatusForRecord status={appealObject?.status} />
                      )}
                    </div>
                    <div className="flex items-center ">
                      <div
                        className={`${
                          !editMode &&
                          'pointer-events-none relative after:left-0 after:h-full after:absolute after:w-full  after:bg-white/30 after:rounded-defaultR '
                        } bg-basic_app_bg flex items-center w-fit p-1 rounded-defaultR`}
                      >
                        {[
                          {
                            id: null,
                            icon: criteria.settings?.rating_scale?.items.some((sc) => sc.icon)
                              ? '100'
                              : undefined,
                            color: '4color',
                            rating: undefined,
                            desc: t('no_value'),
                          },
                          ...(criteria.settings?.rating_scale?.items || []),
                        ]?.map((scale, scaleIndex) => {
                          return (
                            <TooltipWrapper
                              key={scale.desc + scale.id + index}
                              content={
                                scale.id
                                  ? `${t('score')}: ${
                                      typeof scale?.rating === 'number'
                                        ? scaleRatingFilter(scale?.rating)
                                        : 'N/A'
                                    }`
                                  : undefined
                              }
                              id={
                                scale.desc +
                                scale.id +
                                index +
                                scaleIndex +
                                scale.rating +
                                scale.color
                              }
                            >
                              <div
                                className={`p-2 text-[14px] cursor-pointer rounded-defaultR flex items-center justify-center ${
                                  scale.id === null && 'pointer-events-none'
                                } ${
                                  scale.id === criteriaEditObject[criteria.id].result?.id &&
                                  'bg-white/70'
                                }`}
                                onClick={() => {
                                  setCriteriaEditObject((prev) => ({
                                    ...prev,
                                    [criteria.id]: {
                                      ...prev[criteria.id],
                                      result: { id: scale.id as number },
                                    },
                                  }));
                                }}
                              >
                                {scale.icon ? (
                                  <Icon
                                    size={scale.id ? 23 : 19}
                                    key={scalesColorsMap[criteria.id][scale.id as number]}
                                    name={pictogramsData[scale.icon]}
                                    className={`${scale.id === null && `text-${scale.color}`}`}
                                    customStyle={{ color: scale.id !== null ? scale.color : '' }}
                                    {...(scale.id === null ? {} : {})}
                                  />
                                ) : scale.desc ? (
                                  scale.desc
                                ) : (
                                  scale.rating
                                )}
                              </div>
                            </TooltipWrapper>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  {/* COMMENTS ~button */}
                  {/* /// */}
                  <div className="flex items-start gap-[10px] h-full basis-[127px]">
                    <div>
                      {criteriaEditObject[criteria.id].result?.id && (
                        <DisplayScoreComponent
                          score={scaleRatingFilter(
                            criteria.settings.rating_scale?.items.find(
                              ({ id }) => criteriaEditObject?.[criteria.id]?.result?.id === id,
                            )?.rating,
                          )}
                          color={
                            criteria.settings.rating_scale?.items.find(
                              ({ id }) => criteriaEditObject?.[criteria.id]?.result?.id === id,
                            )?.color
                          }
                          maxScore={criteria.evaluation.score.max_calc}
                        />
                      )}
                    </div>
                    {/* /// */}
                    <div
                      className={`flex items-center cursor-pointer ${
                        appealObject && appealResolveMode && 'hidden'
                      }`}
                    >
                      <CircleButton
                        onClick={() =>
                          setCommentBlock((prev) =>
                            prev?.includes(criteria.id)
                              ? prev?.filter((id) => id !== criteria.id)
                              : [...prev, criteria.id],
                          )
                        }
                        icon="CloudMessageIcon"
                        className={`text-action`}
                        size={16}
                      />
                      {editMode}
                      {!!criteria.comments.history.length && (
                        <div className="text-white p-[1px_6px] text-[10px] bg-action rounded-full flex items-center justify-center">
                          {criteria.comments.history.length}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* COMMENTS ~button */}
                </div>
                <div className="py-2">
                  {commentBlock?.includes(criteria.id) && (
                    <Box className="w-full min-h-[80px] max-h-[200px] relative flex flex-col justify-between  !bg-basic_app_bg">
                      <div className="h-full overflow-auto">
                        <HistoryComponent
                          comments
                          historyComments={criteria.comments}
                          status={appealObject?.status}
                          history={criteria.comments.history}
                        />
                      </div>
                      {editMode && (
                        <div className="p-2 sticky bottom-0 w-full z-[99]">
                          {criteria.comments.type === 'INPUT' ? (
                            <Input
                              placeholder={t('comment_placeholder')}
                              defaultValue={criteriaEditObject?.[criteria.id]?.comment?.value}
                              onChange={(event) => {
                                const value = event.target.value;
                                setCriteriaEditObject((prev) => ({
                                  ...prev,
                                  [criteria.id]: { ...prev[criteria.id], comment: { value } },
                                }));
                              }}
                            />
                          ) : (
                            <Select
                              dropWidth={246}
                              options={
                                criteria.comments?.settings?.select.map((select) => {
                                  return criteria.comments.settings?.display_type === 'ICON'
                                    ? {
                                        value: select.id,
                                        title: select.icon || 0,
                                      }
                                    : criteria.comments.settings?.display_type === 'VALUE_ICON'
                                    ? {
                                        value: select.id,
                                        title: select.desc,
                                        icon: pictogramsData[select.icon?.toString() || 0],
                                      }
                                    : {
                                        value: select.id,
                                        title: select.desc,
                                      };
                                }) || []
                              }
                              defaultValue={criteriaEditObject?.[criteria.id]?.comment?.value}
                              onChange={(value) => {
                                setCriteriaEditObject((prev) => ({
                                  ...prev,
                                  [criteria.id]: { ...prev[criteria.id], comment: { value } },
                                }));
                              }}
                              pictogramsMode={criteria.comments.settings?.display_type === 'ICON'}
                            />
                          )}
                        </div>
                      )}
                    </Box>
                  )}
                </div>
                {/* COMMENTS ~BLOCK APPEAL */}
              </div>
            </div>
          );
        })}
    </div>
  );
};
export default CriteriaListMarkup;
